import axios from 'axios';
import moment from 'moment';
import UrlEndPoints from './urlEndPoints.json';
import {
  KEY_ACCESS_TOKEN,
  KEY_CONFIG_URL,
  KEY_DATE_FORMAT,
  KEY_LOGIN_ACCESS_TOKEN,
  REACT_APP_CONFIG_JSON,
  KEY_AZURE_WEBSITE_URL,
} from '../Helpers/constant';
// import { ApiConfig } from '../Containers/Events/utils/interfaces';
import { RRuleSet, rrulestr } from 'rrule';
import dayjs from 'dayjs';
import { getUri } from '../Helpers/userAgentApplication';
import { Questionnaire } from '../interfaces/Service';
import { FormPostJobFavorite } from '../interfaces/Jobs';
import { method } from 'lodash';

let appConfig: any;
export let axiosInstance: any;
const configUrl = KEY_CONFIG_URL;
let paymentInstance: any;
let integrationInstance: any;

const getInsConfig = (config: any) => {
  return config;
};

export const getAxiosInstance = async (data: any) => {
  appConfig = data[0]?.config;
  // appConfig.apiBaseUrl = "http://localhost:4000/api"
  appConfig.apiBaseUrl = "https://ltpct-stage-api.ken42.com/pfs-integration/api"
  appConfig.bbbmiddleware = "https://ltpct-stage-api.ken42.com/pfs-integration/api"
  // appConfig.bbbmiddleware = "http://localhost:4000/api"
  localStorage.setItem('fileToken', appConfig.lmsToken);
  if (axiosInstance) {
    return axiosInstance;
  }
  axiosInstance = axios.create({
    baseURL: `https://ltpct-stage-api.ken42.com/pfs-integration/api`,
    // baseURL: 'http://localhost:4000/api',
    timeout: 15000,
  });

  axiosInstance.interceptors.request.use((req: any) => {
    const token = localStorage.getItem(KEY_ACCESS_TOKEN);
    req.headers['access-token'] = localStorage.getItem(KEY_LOGIN_ACCESS_TOKEN);
    req.headers.Authorization = `Bearer ${token}`;
    return req;
  });

  //Response interceptor for API calls
  axiosInstance.interceptors.response.use(
    (resp: any) => {
      return resp;
    },
    async function (error: any) {
      // console.log('ApiService: Interceptor: ', error);
      if (!error.response?.config && error.response?.status !== 401) {
        return error;
      }
      var config = {
        method: 'get',
        // baseURL: `${appConfig.apiBaseUrl}/token?grant_type=client_credentials`,
        // headers: {
        //   Authorization: `Basic ${appConfig.tokenHeader}`,
        // },
        baseURL: `${appConfig.tokenUrl}`,
      };
      return axios(config).then(function (response) {
        localStorage.setItem(KEY_ACCESS_TOKEN, response.data.access_token);
        error.response.config.headers['Authorization'] = `Bearer ${response.data.access_token
          }`;
        return axios(error.response.config);
      });
    }
  );
};

export const getIntegrationInstance = async () => {
  if (integrationInstance) {
    return integrationInstance;
  }
  integrationInstance = axios.create({
    baseURL: `${appConfig.bbbmiddleware}`,
    timeout: 15000,
  });

  integrationInstance.interceptors.request.use((req: any) => {
    const token = localStorage.getItem(KEY_ACCESS_TOKEN);
    req.headers.Authorization = `Bearer ${token}`;
    req.headers['access-token'] = localStorage.getItem(KEY_LOGIN_ACCESS_TOKEN);
    return req;
  });

  //Response interceptor for API calls
  integrationInstance.interceptors.response.use(
    (resp: any) => {
      return resp;
    },
    async function (error: any) {
      var config = {
        method: 'get',
        baseURL: `${appConfig.tokenUrl}`,
      };
      return axios(config).then(function (response) {
        localStorage.setItem(KEY_ACCESS_TOKEN, response.data.access_token);
        error.response.config.headers['Authorization'] = `Bearer ${response.data.access_token
          }`;
        return axios(error.response.config);
      });
    }
  );
  return integrationInstance;
};

export const createQuiz = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.createQuiz}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

//Publish/Unpublish quiz, assignments, resources etc.
export const publishUnpublishLMSModule = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.publishUnpublishLMSModule}`,
    {
      method: "post",
      quizid: data.id,
      publish: data.publish
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const getPaymentInstance = async (data: any) => {
  appConfig = await getInsConfig(data[0].config);
  paymentInstance = await axios.create({
    baseURL: `${appConfig.paymentBaseUrl}`,
    timeout: 15000,
  });
};

// Request interceptor for API calls

// const ApiService = (method: 'get' | 'post' | 'patch' | 'put' | 'delete', url: string, config: ApiConfig | null = null) => {
//   switch (method) {
//     case 'get':
//       return axiosInstance.get(url);

//     case 'post':
//       return axiosInstance.post(url, config?.body || {});

//     case 'patch':
//       return axiosInstance.patch(url, config?.body || {});

//     case 'put':
//       return axiosInstance.put(url, config?.body || null);

//     case 'delete':
//       return axiosInstance.delete(url);

//     default:
//       console.log('axios default: ', method, url, config);
//       break;
//   }
// };

// export const PaymentApiService = (
//   method: 'get' | 'post' | 'put' | 'delete',
//   url: string,
//   config: ApiConfig | null = null
// ) => {
//   switch (method) {
//     case 'get':
//       return paymentInstance.get(url);

//     case 'post':
//       return paymentInstance.post(url, config?.body || {});

//     case 'put':
//       return paymentInstance.put(url, config?.body || null);

//     case 'delete':
//       return paymentInstance.delete(url);

//     default:
//       console.log('axios default: ', method, url, config);
//       break;
//   }
// };

export const getWhoAmI = async (contactId: any) => {
  const res = await axiosInstance.get(
    `/${UrlEndPoints.WhoAmI}?emailId=${contactId}`
  );
  return res && res.data ? res.data : null;
};

export const authenticate = async (email: any) => {
  const res = await axiosInstance.get(
    `/${UrlEndPoints.authenticate}?UniqueId=${email}`
  );
  return res && res.data ? res.data : null;
};

export const getStudentDetails = async (contactId: any) => {
  const res = await axiosInstance.get(`/${UrlEndPoints.contact}/${contactId}`);
  return res && res.data ? res.data : null;
};

export const getStudentInfo = async (contactId: any) => {
  const res = await axiosInstance.get(
    `${appConfig.bbbmiddleware
    }/sf/data?api=services/apexrest/ContactDetail/${contactId}`
  );
  // console.log('res-----------------------', res);
  // https://api-v2.ken42.com/sp-jain/stage/pfs/sf/data?api=services/apexrest/ContactDetail/0031y00000KwGxrAAF
  // https://api-v2.ken42.com/sp-jain/stage/pfs/sf/data?api=services/apexrest/ContactDetail/0031y00000KwGxrAAF
  return res && res.data ? res.data : null;
};

export const getAttendanceInfo = async (
  contactId: any,
  startDate = '',
  endDate = ''
) => {
  const query = encodeURIComponent(
    `services/apexrest/StudentAttendanceData?contactId=${contactId}&StartDate=${startDate}&EndDate=${endDate}`
  );
  const res = await axiosInstance.get(
    `${appConfig.bbbmiddleware}/sf/data?api=${query}`
  );
  return res && res.data ? res.data : null;
};

// Attendance events
export const getAttendanceEvent = async (
  contactId: any,
  courseOffering = '',
  startDate = '',
  endDate = ''
) => {
  const query = encodeURIComponent(
    `services/apexrest/attendancebyStudent/?contactId=${contactId}&courseOfferingId=${courseOffering}&startDate=${startDate}&endDate=${endDate}`
  );
  const res = await axiosInstance.get(
    `${appConfig.bbbmiddleware}/sf/data?api=${query}`
  );
  return res && res.data ? res.data : null;
};

export const getProfileImageData = async (courseOfferingId: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/ContactAttachment/?recordId=${courseOfferingId}&fileName=passportPhoto`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const saveStudentEducationInfo = async (data: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/EducationHistoryApi`);

  const res = await axiosInstance.post(`${path}${query}`, { records: data });
  return res && res.data ? res.data : null;
};

export const saveStudentProfileImage = async (data: any, contactId: any) => {
  const headers = {
    'Content-Type': 'multipart/form-data',
  };
  const path = `${appConfig.bbbmiddleware}`;
  const query = `/report/signature?programEnrollmentId=${contactId}&fileName=passportPhoto`;

  const res = await axiosInstance.post(`${path}${query}`, data, headers);
  return res && res.data ? res.data : null;
};

export const saveStudentAddressInfo = async (data: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/Address`);
  const newData = data.map((ele: any) => {
    return ele.add;
  });
  const res = await axiosInstance.post(`${path}${query}`, { records: newData });
  return res && res.data ? res.data : null;
};

export const saveResearchSuperVision = async (data: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/createAdditionalInfo`);
  const newData = {
    Operation: 'Create',
    AdditionalInformation: data,
  };
  const res = await axiosInstance.post(`${path}${query}`, newData);
  return res && res.data ? res.data : null;
};

export const saveStudentRelationInfo = async (data: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/Relationship`);

  const newData = data.map((ele: any) => {
    return ele.res;
  });
  const res = await axiosInstance.post(`${path}${query}`, { records: newData });
  return res && res.data ? res.data : null;
};
export const saveStudentProfileInfo = async (data: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/ContactDetail`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const saveFacultyAddressInfo = async (data: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/Address`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const getFacultyDetails = async (academicProgramId: any) => {
  const res = await axiosInstance.get(
    `${UrlEndPoints.faculty}/${academicProgramId}`
  );
  return res && res.data ? res.data : null;
};

export const getAllCourses = async (contactId: any, programId: any) => {
  const res = await axiosInstance.get(
    `${UrlEndPoints.getallcourse}/${contactId}/${programId}`
  );
  return res && res.data ? res.data : null;
};

export const getSchedule = async (contactId: any) => {
  const res = await axiosInstance.get(
    `/${UrlEndPoints.whyiamhere}/${contactId}`
  );

  return res && res.data ? res.data : null;
};

export const getEvents = async (ContactID: any) => {
  const res = await axiosInstance.get(`/${UrlEndPoints.event}/${ContactID}`);
  return res && res.data ? res.data : null;
};

export const getStudents = async (courseOfferingId: any) => {
  const path = `/${UrlEndPoints.getstudent}/${courseOfferingId.trim()}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

export const getStudentsBySection = async (programPlanId: any, section: any) => {
  const path = `/${UrlEndPoints.studentBySection
    }/${programPlanId.trim()}/${section}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

export const postAttendance = async (data: any) => {
  const res = await axiosInstance.post(
    `/${UrlEndPoints.submit_attendance}`,
    data
  );
  return res && res.data ? res.data : null;
};

export const getAbsentParentDetails = async (data: any) => {
  const res = await axiosInstance.post(
    `/${UrlEndPoints.absent_parent_details}`,
    data
  );
  return res && res.data ? res.data : null;
};
export const sendSms = async (data: any) => {
  const res = await axios.get(`${appConfig.smsbaseURL}send_to=${data}`);
  return res && res.data ? res.data : null;
};
// get courses for faculty
export const getCourses = async (contactId: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `services/apexrest/courseConnections/?contactId=${contactId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  if (res?.data?.success === 'true') {
    return res.data.Data.map((el: any) => {
      return {
        ...el,
        hed__Course__cName: el.CourseName,
        hed__Course__cId: el.CourseId,
        hed__Term__c: el.TermName,
      };
    });
  } else {
    return [];
  }
};

// get grade details
export const getGradeDetails = async () => {
  const path = `/${UrlEndPoints.gradeType}`;
  const res = await axiosInstance?.get(path);
  return res && res.data ? res.data : null;
};

// get exam details
export const getExamDetails = async () => {
  const path = `/${UrlEndPoints.examType}`;
  const res = await axiosInstance?.get(path);
  return res && res.data ? res.data : null;
};

// scholastic grade distribution

export const getScholasticGrade = async () => {
  const path = `/${UrlEndPoints.scholasticGradeDistribution}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

export const getCoScholasticGrade = async () => {
  const path = `/${UrlEndPoints.coScholasticGradeDistribution}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

export const getMarketplaceURL = async (params: any) => {
  const path = `/${UrlEndPoints.marketplace}`;
  const res = await integrationInstance.get(`${path}?${params}`);
  return res && res.data ? res.data : null;
};

//Get payment schedule
export const getPaymentSchedule = async (contactId: any, orgID: any) => {
  const path = `/${UrlEndPoints.pendingFees
    }/${contactId.trim()}?orgId=${orgID.trim()}`;
  const res = await paymentInstance.get(path);
  return res && res.data ? res.data : null;
};

//Get payment history
export const getPaymentHistory = async (contactId: any, orgID: any) => {
  const path = `/${UrlEndPoints.paymentHistory
    }/${contactId.trim()}?orgId=${orgID.trim()}`;
  const res = await paymentInstance.get(path);
  return res && res.data ? res.data : null;
};

export const payNow = async (data: any) => {
  const path = `/${UrlEndPoints.paynow}?orgId=${appConfig.orgID}`;
  const res = await paymentInstance.post(path, data);
  return res && res.data ? res.data : null;
};

export const addPay = async (data: any) => {
  const path = `/${UrlEndPoints.addPayment}`;
  const res = await paymentInstance.post(path, data);
  return res && res.data ? res.data : null;
};

export const feesInfo = async (contactID: any, orgID: any) => {
  const path = `/${UrlEndPoints.feesinfo
    }/${contactID.trim()}?orgId=${orgID.trim()}`;
  const res = await paymentInstance.get(path);
  return res && res.data ? res.data : null;
};

export const getParentDetails = async (phoneNo: any) => {
  const path = `/${UrlEndPoints.parent}/${phoneNo.trim()}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

export const facultyActivities = async (
  contactID: any,
  connectionID: any,
  startDate: any,
  endDate: any
) => {
  startDate = moment()
    .subtract(6, 'month')
    .format(KEY_DATE_FORMAT)
    .toLowerCase();
  endDate = moment()
    .add(6, 'months')
    .format(KEY_DATE_FORMAT)
    .toLowerCase();
  const data = {
    useridnumber: contactID,
    connectionid: connectionID,
    modtype: '',
    startdate: startDate,
    enddate: endDate,
    generalsection: '',
    method: 'POST',
  };
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.activities}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
export const StudentActivities = async (
  contactID: any,
  connectionID: any,
  generalId: any,
  startDate: any,
  endDate: any
) => {
  startDate = moment()
    .subtract(6, 'month')
    .format(KEY_DATE_FORMAT)
    .toLowerCase();
  endDate = moment()
    .add(6, 'months')
    .format(KEY_DATE_FORMAT)
    .toLowerCase();
  const data = {
    useridnumber: contactID,
    connectionid: '',
    modtype: '',
    generalsection: generalId ? '1' : '',
    startdate: startDate,
    enddate: endDate,
  };
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.studentactivities}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const getConfig = async () => {
  // const path = `${window.location.host}`;
  // const path = 'ltpct-portal.ken42.com';
  // const path = 'ltpct-stg-portal.ken42.com';
  // const res = await axios.get(`${configUrl}/${path}`);
  // return res && res.data ? res.data : null;
  try{
    const configJson = REACT_APP_CONFIG_JSON;
        if (!configJson) {
          console.warn('CONFIG_JSON not found in environment variables');
          return null;
        }
    
        const config = typeof configJson === "string" ? JSON.parse(configJson) : configJson;
        return config;
      } catch (error) {
        console.error('Error parsing CONFIG_JSON:', error);
        return null;
      }
};

export const putAccountDetails = async (studentId: any, data: any) => {
  const path = `${UrlEndPoints.accountDetails}`;
  const res = await axios.put(
    `${appConfig.paymentBaseUrl}/${path}/${studentId}`,
    data
  );
  return res && res.data ? res.data : null;
};

export const getAccountDetails = async (studentId: any) => {
  const path = `${UrlEndPoints.accountDetails}`;
  const res = await axios.get(
    `${appConfig.paymentBaseUrl}/${path}/${studentId}?orgId=${appConfig.orgID}`
  );
  return res && res.data ? res.data : null;
};

// export const getOtp = async params => {
//   const path = `otp`;
//   const res = await axiosInstance.get(`${appConfig.smsURL}/${path}?${params}`);
//   return res && res.data ? res.data : null;
// };
export const getOtp = async (params: any, p0: boolean) => {
  const path = `otp`;
  const res = await axiosInstance.get(
    `${appConfig.bbbmiddleware}/${path}?${params}`
  );
  return res && res.data ? res.data : null;
};

export const subscribe = async (data: any) => {
  const path = `notification/subscribeWeb`;
  const res = await axiosInstance.post(
    `${appConfig.firebaseBaseURL}/${path}`,
    data
  );
  return res && res.data ? res.data : null;
};

export const unsubscribe = async (data: any) => {
  const path = `notification/unsubscribeWeb`;
  const res = await axiosInstance.post(
    `${appConfig.firebaseBaseURL}/${path}`,
    data
  );
  return res && res.data ? res.data : null;
};

// export const getValidateOtp = async params => {
//   const path = `/validateotp`;
//   const res = await axiosInstance.get(`${appConfig.smsURL}/${path}?${params}`);
//   return res && res.data ? res.data : null;
// };
export const getValidateOtp = async (params: any) => {
  const path = `validateotp`;
  const res = await axiosInstance.get(
    `${appConfig.bbbmiddleware}/${path}?${params}`
  );
  return res && res.data ? res.data : null;
};

// TODO: remove hardcode
export const sendMail = async (data: any) => {
  const path = `email`;
  const res = await axiosInstance.post(
    `https://api.ken42.com/vks/pfs/v1/${path}`,
    data
  );
  return res && res.data ? res.data : null;
};

export const getAllEvents = async (contactId: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `services/apexrest/eventsData/?contactId=${contactId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};

export const requestForOTP = async (payload: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/PFSOtp/send?contact=${payload}`
  )}`;
  const res = await axiosInstance.post(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};
export const verifyOTP = async (payload: any) => {
  const path = `salesforce?endpoint=/services/apexrest/PFSOtp/verify&contact=${payload.id
    }&otpentered=${payload.otp}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};

/* usename password API */
export const requestForSignIN = async (username: any, password: any) => {
  const path = `salesforce?endpoint=/services/apexrest/SignInAPI?username=${username}%26password=${password}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};
export const getVerifyUsername = async (username: any, password: any) => {
  const path = `salesforce?endpoint=/services/apexrest/VerifyUsername?username=${username}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};
export const postChangePassword = async (data: any) => {
  // const path = `salesforce?endpoint=/services/apexrest/ChangePassword`;
  // const res = await axiosInstance.post(
  //   `${appConfig.bbbmiddleware}/${path}`,
  //   data
  // );
  const path = `${appConfig.bbbmiddleware}/salesforce?endpoint=`;
  const query = encodeURIComponent(`services/apexrest/ChangePassword`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const getAllRegisterEvents = async (contactId: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `services/apexrest/eventsData/?contactId=${contactId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};

export const getReportCardDetails = async (
  contactId: any,
  programEnrollmentId: any,
  loginContactId: any
) => {
  const path = `report/details`;
  const res = await axiosInstance.get(
    `${appConfig.bbbmiddleware
    }/${path}?contactId=${contactId}&programEnrollmentId=${programEnrollmentId}&loginContactId=${loginContactId}`
  );
  return res && res.data ? res.data : null;
};

// Query Comments

export const getCommentsById = async (id: any) => {
  if (!id) return;
  const path = `/${UrlEndPoints.comments}/${id}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

export const postComments = async (ContactId: any, Comment: any, ParentId: any) => {
  const path = `/${UrlEndPoints.comments}`;
  const res = await axiosInstance.post(path, { ContactId, Comment, ParentId });
  return res && res.data ? res.data : null;
};
export const postBreakdownMarks = async (data: any) => {
  const path = '/submit-additional-grade-pfs';
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getEventDetails = async (eventId: any, contactId: any) => {
  const res = await axiosInstance.get(
    `${appConfig.apiBaseUrl}/eventsubsciber/${eventId}/${contactId}`
  );
  return res && res.data ? res.data : null;
};

export const registersEvent = async (payload: any) => {
  const res = await axiosInstance.post(
    `${appConfig.apiBaseUrl}/subscribeevent`,
    payload
  );
  return res && res.data ? res.data : null;
};

export const unRegistersEvent = async (eventId: any) => {
  const res = await axiosInstance.delete(
    `${appConfig.apiBaseUrl}/unsubscibeevent/${eventId}`
  );
  return res && res.data ? res.data : null;
};

export const postScholasticMarks = async (data: any) => {
  const path = '/submit-main-grade-pfs';
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const postScholasticMainMarks = async (data: any) => {
  const path = '/submit-grade-pfs';
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const postCoScholasticMarks = async (data: any) => {
  const path = '/submit-coscholastic-pfs';
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getStudentListDetails = async (
  courseOfferingId: any,
  loginContactId: any
) => {
  const path = `/report/grades`;
  const res = await axiosInstance.get(
    `${appConfig.bbbmiddleware
    }${path}?courseOfferingId=${courseOfferingId}&loginContactId=${loginContactId}`
  );
  return res && res.data ? res.data : null;
};

export const getSignature = async (programEnrollmentId: any, fileName: any) => {
  const path = `/report/signature`;
  const res = await axiosInstance.get(
    `${appConfig.bbbmiddleware
    }${path}?programEnrollmentId=${programEnrollmentId}&fileName=${fileName}`
  );
  return res && res.data ? res.data : null;
};

export const uploadSignature = async (programEnrollmentId: any, fileName: any, data: any) => {
  const path = `/report/signature`;

  const apiUrl = `${appConfig.bbbmiddleware
    }${path}?programEnrollmentId=${programEnrollmentId}&fileName=${fileName}`;

  let formData = new FormData();
  formData.append('signature', data);

  const res = await axiosInstance.post(apiUrl, formData);
  return res && res.data ? res.data : null;
};

export const getConsolidatedMarks = async (classId: any, sectionName: any) => {
  const path = `/report/consolidatedReports`;
  const res = await axiosInstance.get(
    `${appConfig.bbbmiddleware
    }${path}?classId=${classId}&sectionName=${sectionName}`
  );
  return res && res.data ? res.data : null;
};

//Timetable---------------------------------------------------------------------------------

//Get all time blocks
export const getAllTimeBlocks = async (instituteId: any) => {
  const path = `/alltimeblock`;
  const res = await axiosInstance.get(
    `${appConfig.apiBaseUrl}${path}/${instituteId}`
  );
  return res && res.data ? res.data : null;
};

//get teacher time table
export const getTimetableByContactId = async (date: any, instituteId: any, contactId: any) => {
  let formattedDate;
  if (date instanceof Date) {
    formattedDate = moment(date).format('YYYY-MM-DD');
  }
  const path = `/facultytimetable`;
  const res = await axiosInstance.get(
    `${appConfig.apiBaseUrl
    }${path}/${formattedDate}/${instituteId}/${contactId}`
  );
  return res && res.data ? res.data : null;
};

// SalesforceAPIs
export const getSalesforceData = async (data: any) => {
  const path = encodeURIComponent(`${data}`);
  const res = await axiosInstance.get(
    `${appConfig.bbbmiddleware}/${UrlEndPoints.FeeInventory}?api=${path}`
  );
  return res && res.data ? res.data : null;
};
export const getSalesforceBaseData = async (data: any) => {
  const path = encodeURIComponent(`${data}`);
  const res = await axiosInstance.get(
    `${appConfig.bbbmiddleware}/salesforce?endpoint=${path}`,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      responseType: 'arraybuffer',
    }
  );
  return res && res.data ? res.data : null;
};
// Fee Management Common
export const getStudentDetailsByContact = async (data: any) => {
  return getSalesforceData(`StudentDetailAPI/${data}`);
};
// My Cart
export const getFeeInventoryByContact = async (data: any) => {
  return getSalesforceData(`FeeScheduleAPI/${data}`);
};
export const postFeeInventoryByContact = async (params: any, data: any) => {
  const path = encodeURIComponent(`CartDefaultFee/${params}`);
  const res = await axiosInstance.post(
    `${appConfig.bbbmiddleware}/${UrlEndPoints.PostFeeInventory}?api=${path}`,
    data
  );
  return res && res.data ? res.data : null;
};

// Fee Schedule
export const getFeeScheduleByContact = async (data: any) => {
  return getSalesforceData(`PaymentSchedule/${data}`);
};

// Fee Payment
export const getFeePaymentByContact = async (data: any) => {
  return getSalesforceData(`FeeLineItem/${data}`);
};

export const postFeePaymentByContact = async (data: any) => {
  const path = encodeURIComponent(`payment_links`);
  const res = await axiosInstance.post(
    `${appConfig.bbbmiddleware}/payment_links`,
    data
  );
  return res && res.data ? res.data : null;
};

// My Transactions
export const getMyTransactionsByContact = async (data: any) => {
  return getSalesforceData(`ActualPayment/${data}`);
};

export const getMyReceiptsByContact = async (data: any) => {
  return getSalesforceBaseData(
    `services/data/v53.0/sobjects/Attachment/${data}/Body`
  );
};

//get timetable (student/parent)
export const getTimetable = async (date: any, instituteId: any) => {
  let formattedDate;
  if (date instanceof Date) {
    formattedDate = moment(date).format('YYYY-MM-DD');
  }
  const path = `/gettimetable`;
  const res = await axiosInstance.get(
    `${appConfig.apiBaseUrl}${path}/${formattedDate}/${instituteId}`
  );
  return res && res.data ? res.data : null;
};

export const getAttendancePercentage = async (data: any) => {
  const path = encodeURIComponent(`getAttendancePercentage?${data}`);
  const res = await axiosInstance.get(
    `${appConfig.bbbmiddleware}/${UrlEndPoints.attendancePercentage
    }?api=${path}`
  );
  return res && res.data ? res.data : null;
};

// Virtual class
export const getRecordings = async (meetingId: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance?.get(
    `${UrlEndPoints.getRecordings}?meetingID=${meetingId}`
  );
  return res && res.data ? res.data : null;
};

export const getQuestionBankFilters = async (contactId: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.questionBankFilters}`,
    { method: 'get', contactid: contactId },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const getAttributes = async (contactID: any) => {
  const path = `${UrlEndPoints.attributes}/${contactID}`;
  const res = await axiosInstance.get(`${appConfig?.appBaseUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const createAttribute = async (data: any) => {
  const path = `${UrlEndPoints.attributes}`;
  const res = await axiosInstance.post(
    `${appConfig?.appBaseUrl}/${path}`,
    data
  );
  return res && res.data ? res.data : null;
};

//-----------------------Faculty/Admin Assessments

export const getQuizQuestions = async (quizId: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getQuizQuestions}`,
    { method: 'get', quizcmid: quizId },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
export const getQuestionBankQuestions = async (subjectId: any, questionTypes: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.questionBank}`,
    { courseid: subjectId, qtype: questionTypes, method: 'get' },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const getQuestionDetail = async (qId: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.questionDetail}`,
    { questionid: qId, method: 'get' },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const getUpcomingTasks = async (contactId: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.get_upcoming_tasks}`,
    { contactid: contactId, method: 'GET' },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};


const getChoices = (options: any) => {
  if (Array.isArray(options)) {
    return options.map(item => {
      return {
        option: item.option,
        correctanswer: item.correctAnswer,
        feedback: item.feedback,
      };
    });
  } else return [];
};

export const addMCQQuestionToQuiz = async (data: any) => {
  console.log(data, 'data');
  
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.addMCQQuestion}`,
    {
      method: 'post',
      quizid: data?.quizId,
      page: data?.page,
      questionname: data?.questionName,
      questiontext: data?.questiontext,
      defaultmark: data?.defaultMarks,
      penalty: data?.penalty,
      singleanswer: data?.singleAnswer,
      correctfeedback: data?.correctFeedback || '',
      incorrectfeedback: data?.incorrectFeedback || '',
      generalfeedback: data?.generalFeedback || '',
      tags: data?.tags || [],
      choices: getChoices(data?.choices),
      shuffleanswers: data?.shuffleAnswers,
      answernumbering: data?.answerNumbering,
      metadata: data?.metadata || [],
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const updateMCQQuestionToQuiz = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.updateMCQQuestion}`,
    {
      method: 'post',
      quizid: data?.quizId,
      questionid: data?.questionId,
      //   page: data?.page,
      questionname: data?.questionName,
      questiontext: data?.questionText,
      defaultmark: data?.defaultMarks,
      penalty: data?.penalty,
      singleanswer: data?.singleAnswer,
      correctfeedback: data?.correctFeedback,
      incorrectfeedback: data?.incorrectFeedback,
      generalfeedback: data?.generalFeedback,
      tags: data?.tags || [],
      choices: getChoices(data?.choices),
      //   shuffleanswers: data?.shuffleAnswers,
      answernumbering: data?.answerNumbering,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const addQuestionsToQuiz = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.addQuestionsToQuiz}`,
    {
      method: 'post',
      quizid: data?.quizId,
      questions: data?.questions,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const deleteQuestionFromQuiz = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.deleteQuestionFromQuiz}`,
    {
      method: 'post',
      quizid: data?.quizId,
      questionid: data?.questionId,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
//--------------------Short Answer-------------
export const addShortAnswerQuestionBank = async (data: any) => {
  console.log(data, 'data');
  
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.addShortAnswerQuestionBank}`,
    {
      method: 'post',
      courseid: data?.courseId,
      chapter: data?.chapterId ?? 0, 
      questionname: 'shortanswer',
      questiontext: data?.questiontext, 
      defaultmark: data?.defaultmark, 
      generalfeedback: data?.generalfeedback, 
      tags: Array.isArray(data?.tags)
    ? data.tags.map((tag: any) => ({ text: tag }))
    : data?.tags
    ? [{ text: data?.tags }]
    : [],
      choices: data?.choices.map((item: any) => ({
        option: item.option,
        fraction: item.fractiongrade,
        feedback: item.feedback,
      })),
      metadata: [
        {
          field: 'questionpurpose',
          data: data?.metadata?.find((m: any) => m.field === 'questionpurpose')?.questionOutcome || '', 
        },
        {
          field: 'questiondifficultylevel',
          data: data?.metadata?.find((m: any) => m.field === 'questiondifficultylevel')?.difficulty || '',
        },
      ],
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const updateShortAnswerQuestionBank = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.updateShortAnswerQuestionBank}`,
    {
      method: 'post',
      questionid: data?.questionId,
      courseid: data?.courseId,
      chapter: data?.chapterId ?? 0, 
      questionname: 'shortanswer',
      questiontext: data?.questiontext, 
      defaultmark: data?.defaultmark, 
      generalfeedback: data?.generalfeedback, 
      tags: Array.isArray(data?.tags)
    ? data.tags.map((tag: any) => ({ text: tag }))
    : data?.tags
    ? [{ text: data?.tags }]
    : [],
      choices: data?.choices.map((item: any) => ({
        option: item.option,
        fraction: item.fractiongrade,
        feedback: item.feedback,
      })),
      metadata: [
        {
          field: 'questionpurpose',
          data: data?.metadata?.find((m: any) => m.field === 'questionpurpose')?.questionOutcome || '', 
        },
        {
          field: 'questiondifficultylevel',
          data: data?.metadata?.find((m: any) => m.field === 'questiondifficultylevel')?.difficulty || '',
        },
      ],
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
//----------------True/false------------------------

export const addTrueFalseToQuiz = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.addTrueFalseQuestion}`,
    {
      method: 'post',
      quizid: data?.quizId,
      page: data?.page || 1,
      defaultmark: data?.defaultMarks ? data?.defaultMarks : 0,
      questionname: data?.questionName || 'truefalse',
      questiontext: data?.questionText,
      rightanswer: data?.rightAnswer,
      generalfeedback: data?.generalFeedback || '',
      feedbacktrue: data?.correctFeedback || '',
      feedbackfalse: data?.incorrectFeedback || '',
      tags: data?.tags || [],
      metadata: data?.metadata || [],
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const updateTrueFalseToQuiz = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.updateTrueFalseQuestion}`,
    {
      method: 'post',
      quizid: data?.quizId,
      questionid: data?.questionId,
      //   page: data?.page,
      questionname: data.questionName,
      questiontext: data?.questionText,
      rightanswer: data?.rightAnswer,
      generalfeedback: data?.generalFeedback,
      feedbacktrue: data?.correctFeedback,
      feedbackfalse: data?.incorrectFeedback,
      tags: data?.tags || [],
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const addTrueFalseQuestionBank = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.addTrueFalseQuestionBank}`,
    {
      courseid: data?.courseid,
      chapter: data?.chapter,
      method: 'post',
      questionname: '',
      questiontext: data?.questiontext,
      rightanswer: data?.rightanswer,
      generalfeedback: data?.generalfeedback || '',
      defaultmark: data?.defaultmark || 0,
      feedbacktrue: data?.feedbacktrue || '',
      feedbackfalse: data?.feedbackfalse || '',
      tags: Array.isArray(data?.tags)
    ? data.tags.map((tag: any) => ({ text: tag }))
    : data?.tags
    ? [{ text: data?.tags }]
    : [],
      metadata: data?.metadata || [],
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const updateTrueFalseQuestionBank = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.updateTrueFalseQuestionBank}`,
    {
      questionid: data?.questionId,
      courseid: data?.courseid,
      chapter: data?.chapter,
      method: 'post',
      questionname: '',
      questiontext: data?.questiontext,
      rightanswer: data?.rightanswer,
      generalfeedback: data?.generalfeedback || '',
      defaultmark: data?.defaultmark || 0,
      feedbacktrue: data?.feedbacktrue || '',
      feedbackfalse: data?.feedbackfalse || '',
      tags: Array.isArray(data?.tags)
    ? data.tags.map((tag: any) => ({ text: tag }))
    : data?.tags
    ? [{ text: data?.tags }]
    : [],
      metadata: data?.metadata || [],
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

//--------------------Match the following-------------
export const addMatchingQuestion = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.addMatchingQuestion}`,
    {
      method: 'post',
      quizid: data?.quizid,
      page: data?.page,
      questionname: '',
      questiontext: data?.questiontext,
      defaultmark: data?.defaultmark,
      penalty: data?.penalty,
      shuffleanswers: data?.shuffleanswers,
      correctfeedback: data?.correctfeedback,
      incorrectfeedback: data?.incorrectfeedback,
      generalfeedback: data?.generalfeedback,
      partiallycorrectfeedback: data?.partiallycorrectfeedback,
      tags: data?.tags,
      choices: data?.choices,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const updateMatchingQuestion = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.updateMatchingQuestion}`,
    {
      method: 'post',
      quizid: data?.quizid,
      questionid: data?.questionId,
      //   page: data?.page,
      questionname: data?.questionname,
      questiontext: data?.questiontext,
      defaultmark: data?.defaultmark,
      penalty: data?.penalty,
      shuffleanswers: data?.shuffleanswers,
      correctfeedback: data?.correctfeedback,
      incorrectfeedback: data?.incorrectfeedback,
      generalfeedback: data?.generalfeedback,
      partiallycorrectfeedback: data?.partiallycorrectfeedback,
      tags: data?.tags,
      choices: data?.choices,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

//--------------------Subjective-------------
export const addEssayQuestion = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.addEssayQuestion}`,
    {
      method: 'post',
      quizid: data?.quizid,
      page: data?.page,
      questionname: '',
      questiontext: data?.questiontext,
      defaultmark: data?.defaultmark,
      generalfeedback: data?.generalfeedback,
      allowattachments: data?.allowattachments,
      attachmentrequired: data?.attachmentrequired,
      tags: data?.tags,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const updateEssayQuestion = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.updateEssayQuestion}`,
    {
      method: 'post',
      quizid: data?.quizid,
      //   page: data?.page,
      questionname: '',
      questionid: data?.questionId,
      questiontext: data?.questiontext,
      defaultmark: data?.defaultmark,
      generalfeedback: data?.generalfeedback,
      allowattachments: data?.allowattachments,
      attachmentrequired: data?.attachmentrequired,
      tags: data?.tags,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
//--------------------Fill in the Blanks-------------
export const addMissingWordsQuestion = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.addMissingWordsQuestion}`,
    {
      method: 'post',
      quizid: data?.quizid,
      page: data?.page,
      questionname: '',
      questiontext: data?.questiontext,
      defaultmark: data?.defaultmark,
      penalty: data?.penalty,
      correctfeedback: data?.correctfeedback,
      incorrectfeedback: data?.incorrectfeedback,
      generalfeedback: data?.generalfeedback,
      tags: data?.tags,
      choices: data?.choices,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const updateMissingWordsQuestion = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.updateMissingWordsQuestion}`,
    {
      method: 'post',
      quizid: data?.quizid,
      questionid: data?.questionId,
      //   page: data?.page,
      questionname: '',
      questiontext: data?.questiontext,
      defaultmark: data?.defaultmark,
      penalty: data?.penalty,
      correctfeedback: data?.correctfeedback,
      incorrectfeedback: data?.incorrectfeedback,
      generalfeedback: data?.generalfeedback,
      tags: data?.tags,
      choices: data?.choices,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
//--------------------Numerical-------------
export const addNumericalQuestion = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.addNumericalQuestion}`,
    {
      method: 'post',
      quizid: data?.quizid,
      page: data?.page,
      questionname: '',
      questiontext: data?.questiontext,
      defaultmark: data?.defaultmark,
      penalty: data?.penalty,
      generalfeedback: data?.generalfeedback,
      tags: data?.tags,
      choices: data?.choices,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const updateNumericalQuestion = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.updateNumericalQuestion}`,
    {
      method: 'post',
      quizid: data?.quizid,
      questionid: data?.questionId,
      //   page: data?.page,
      questionname: '',
      questiontext: data?.questiontext,
      defaultmark: data?.defaultmark,
      penalty: data?.penalty,
      generalfeedback: data?.generalfeedback,
      tags: data?.tags,
      choices: data?.choices,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

//--------------------Short Answer-------------
export const addShortAnswerQuestion = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.addShortAnswerQuestion}`,
    {
      method: 'post',
      quizid: data?.quizid,
      page: data?.page,
      questionname: 'shortanswer',
      questiontext: data?.questiontext,
      defaultmark: data?.defaultmark,
      // penalty: data?.penalty,
      generalfeedback: data?.generalfeedback,
      tags: data?.tags,
      choices: data?.choices,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const updateShortAnswerQuestion = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.updateShortAnswerQuestion}`,
    {
      method: 'post',
      quizid: data?.quizid,
      questionid: data?.questionId,
      //   page: data?.page,
      questionname: 'shortanswer',
      questiontext: data?.questiontext,
      defaultmark: data?.defaultmark,
      // penalty: data?.penalty,
      generalfeedback: data?.generalfeedback,
      tags: data?.tags,
      choices: data?.choices,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
//-------------student assessments------------------------------------

export const GetAttemptSummary = async (attemptId: any) => {
  const data = {
    attemptid: attemptId,
    method: 'get',
  };
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getAttemptSummary}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  return res && res.data ? res.data : null;
};

export const postProcessAttempt = async (
  attemptId: any,
  answers: any,
  finishattempt: any,
  timeup: any
) => {
  const data = {
    attemptid: attemptId,
    data: answers,
    finishattempt: finishattempt,
    timeup: timeup,
    method: 'post',
  };
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.processAttempt}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  return res && res.data ? res.data : null;
};
/* Assessment get quiz instruction */
export const QuizInstruction = async (quizid: any) => {
  const data = {
    quizid: quizid,
    method: 'GET',
  };
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getQuizInstruction}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  return res && res.data ? res.data : null;
};
/* Assessment 1)  quiz access information */
export const QuizAccessInformation = async (contactId: any, quizId: any) => {
  const data = {
    contactid: contactId,
    quizid: quizId,
    method: 'GET',
  };
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getQuizAccessInformation}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  return res && res.data ? res.data : null;
};
/* Assessment 2) Attempt Access Information */
export const AttemptAccessInformation = async (
  contactId: any,
  quizId: any,
  attemptId: any
) => {
  const data = {
    contactid: contactId,
    quizid: quizId,
    attemptid: '0',
    method: 'GET',
  };
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getAttemptAccessInformation}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  return res && res.data ? res.data : null;
};
/* Assessment 3) view quiz*/
export const ViewQuiz = async (quizId: any) => {
  const data = {
    quizid: quizId,
    method: 'GET',
  };
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.viewQuiz}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  return res && res.data ? res.data : null;
};

/* Assesment 4) get_user_attempts */

export const GetUserAttempts = async (contactId: any, quizId: any) => {
  const data = {
    quizid: quizId,
    contactid: contactId,
    status: 'all',
    includepreviews: '1',
    method: 'GET',
  };
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getUserAttempts}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  return res && res.data ? res.data : null;
};
/* Assesment 5)  start attempt */
export const StartAttempt = async (contactId: any, quizId: any) => {
  const data = {
    quizid: quizId,
    contactid: contactId,
    method: 'POST',
  };
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.startAttempt}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  return res && res.data ? res.data : null;
};

export const getQuizzes = async (courseOffering: any) => {
  const data = { courseoffering: courseOffering };
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getQuizzes}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  return res && res.data ? res.data : null;
};

export const postCoreFileUpload = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.coreFileUpload}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  return res && res.data ? res.data : null;
};

export const postDeleteUploadedFile = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.deleteUploadedFile}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  return res && res.data ? res.data : null;
};
/* ----start Question bank  */
export const getChaptersByCourse = async (courseId: any) => {
  const data = {
    method: 'get',
    courseid: courseId,
  };
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getChaptersByCourse}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  return res && res.data ? res.data : null;
};

export const getUserCourses = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getUserCourses}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

//get session list with filters
export const getAllAttendanceSessionCount = async () => {
  const path = `sf/data?api=${encodeURIComponent(
    `services/apexrest/AttendanceCount`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};

export const getFacultyAttendanceCount = async (facultyId: any) => {
  const path = `sf/data?api=${encodeURIComponent(
    `services/apexrest/AttendanceCount/?facultyId=${facultyId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};
export const getContactAttendanceCount = async (contactId: any) => {
  const path = `sf/data?api=${encodeURIComponent(
    `services/apexrest/AttendanceCount/?contactId=${contactId}`
  )}`;

  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};
export const getFacultyAttendanceCountByOffering = async (
  facultyId: any,
  courseOfferingId: any
) => {
  const path = `sf/data?api=${encodeURIComponent(
    `services/apexrest/AttendanceCount/?facultyId=${facultyId}&courseOfferingId=${courseOfferingId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};
export const getContactAttendanceCountByOffering = async (
  contactId: any,
  courseOfferingId: any
) => {
  const path = `sf/data?api=${encodeURIComponent(
    `services/apexrest/AttendanceCount/?contactId=${contactId}&courseOfferingId=${courseOfferingId}`
  )}`;

  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};

export const getStudentListByCourseOffering = async (courseId: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `services/apexrest/studentsByCourseOffering?CourseOfferingId=${courseId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};

export const getAttendanceByCourseOffering = async (
  courseId: any,
  startTime: any,
  endTime: any,
  dateval: any
) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `services/apexrest/attendanceByCourseOffering?CourseOfferingId=${courseId}&startTime=${startTime}&endTime=${endTime}&dateval=${dateval}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};

export const postAttendanceByCourseOffering = async (data: any) => {
  const path = `api=attendanceByCourseOffering`;
  const res = await axiosInstance.post(
    `${appConfig.bbbmiddleware}/sf/createData?${path}`,
    data
  );
  return res && res.data ? res.data : null;
};

export const addMCQToQuestionBank = async (data: any) => {
  const instance = await getIntegrationInstance();
  console.log(instance, "instanceSet")
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.addMultichoiceQuestionBank}`,
    {
      courseid: data?.courseId, 
      chapter: data?.chapterId || 0, 
      method: 'post',
      questionname: 'mcq', 
      questiontext: data.questiontext || '', 
      defaultmark: data?.defaultmark || 0, 
      penalty: data?.penalty || 0,
      singleanswer: data?.singleanswer ? 1 : 0, 
      correctfeedback: data?.correctfeedback || '',
      incorrectfeedback: data?.incorrectfeedback || '', 
      generalfeedback: data?.generalfeedback || '', 
      tags: data?.tags || [], 
      choices: (data?.choices || []).map((choice: any) => ({
        option: choice.option || '',           
        correctanswer: choice.correctanswer ? 1 : 0,     
        feedback: choice.feedback || ''          
      })),
      metadata: data?.metadata || [],
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  console.log(res, "resSet")
  return res && res.data ? res.data : null;
};

export const updateMCQToQuestionBank = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.updateMultichoiceQuestionBank}`,
    {
      questionid: data?.questionId,
      courseid: data?.courseId, 
      chapter: data?.chapterId || 0, 
      method: 'post',
      questionname: 'mcq', 
      questiontext: data.questiontext || '', 
      defaultmark: data?.defaultmark || 0, 
      penalty: data?.penalty || 0,
      singleanswer: data?.singleanswer ? 1 : 0, 
      correctfeedback: data?.correctfeedback || '',
      incorrectfeedback: data?.incorrectfeedback || '', 
      generalfeedback: data?.generalfeedback || '', 
      tags: data?.tags || [], 
      choices: (data?.choices || []).map((choice: any) => ({
        option: choice.option || '',           
        correctanswer: choice.correctanswer ? 1 : 0,     
        feedback: choice.feedback || ''          
      })),
      metadata: data?.metadata || [],
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const postFeePaymentUsingFlywire = async (data: any) => {
  const res = await axiosInstance.post(
    `${appConfig.bbbmiddleware}/payments/flywire/initiate`,
    data
  );
  return res && res.data ? res.data : null;
};

export const getCourseEnrollment = async (contactID: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/CoursesByContactActiveEnrol?contactId=${contactID}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};

export const getCourseOfferingByCourseAndTerm = async (payload: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/CourseOfferingByCourseAndTerm?TermId=${payload.TermId
    }&CourseId=${payload.CourseId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};

export const getRecordingsByCourseOffering = async (courseOfferingId: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `services/apexrest/recording?courseOfferingId=${courseOfferingId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};

export const updateRecordingsByCourseOffering = async (recordingId: any, data: any) => {
  const path = `endpoint=${encodeURIComponent(
    `services/apexrest/recording?recordingId=${recordingId}`
  )}`;

  const res = await axiosInstance.patch(
    `${appConfig.bbbmiddleware}/salesforce/?${path}`,
    data
  );
  return res && res.data ? res.data : null;
};
export const addEssayQuestionBank = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.addEssayQuestionBank}`,
    {
      method: 'get',
      courseid: data?.courseId,
      chapter: 0,
      questionname: '',
      questiontext: data?.questiontext,
      defaultmark: data?.defaultmark,
      generalfeedback: data?.generalfeedback,
      allowattachments: data?.allowattachments,
      attachmentrequired: data?.attachmentrequired,
      tags: Array.isArray(data?.tags)
    ? data.tags.map((tag: any) => ({ text: tag }))
    : data?.tags
    ? [{ text: data?.tags }]
    : [],
    },
    
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
export const updateEssayQuestionBank = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.updateEssayQuestionBank}`,
    {
      method: 'get',
      questionid: data?.questionId,
      courseid: data?.courseId,
      chapter: 0,
      questionname: '',
      questiontext: data?.questiontext,
      defaultmark: data?.defaultmark,
      generalfeedback: data?.generalfeedback,
      allowattachments: data?.allowattachments,
      attachmentrequired: data?.attachmentrequired,
      tags: Array.isArray(data?.tags)
    ? data.tags.map((tag: any) => ({ text: tag }))
    : data?.tags
    ? [{ text: data?.tags }]
    : [],
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

//
export const getCourseActivities = async (
  connectionId: any,
  contactId: any,
  activityType: any
) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getCourseActivities}`,
    {
      connectionid: connectionId,
      contactid: contactId,
      allsection: 1,
      addtionalinfo: 1,
      activitytype: activityType,
      method: 'get',
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
export const getQuizSettingsById = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getQuizSettings}`,
    {
      method: 'get',
      quizid: data?.quizid,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const createSectionInQuiz = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.createSectionInQuiz}`,
    {
      method: 'post',
      page: data?.page,
      quizid: data?.quizid,
      section: data?.section,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const postCourseEnrolmentByTerm = async (payload: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/createCourseEnrolmentByTerm`
  );
  const res = await axiosInstance.post(`${path}${query}`, payload);
  return res && res.data ? res.data : null;
};
// Completed Enrollment
export const getCompletedEnrollment = async (contactID: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/courseconnectionByContactId?contactId=${contactID}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};
// Student Feedback Form
export const getStudentFeedbackDetails = async (contactID: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/api/FacultyFeedback/${contactID}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};
export const getProgramFeedbackDetails = async (contactID: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/api/ProgramFeedback/${contactID}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};
export const postProgramFeedbackDetails = async (payload: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/api/ProgramFeedback`);
  const res = await axiosInstance.post(`${path}${query}`, payload);
  return res && res.data ? res.data : null;
};
export const postStudentFeedbackDetails = async (payload: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/api/FacultyFeedback`);
  const res = await axiosInstance.post(`${path}${query}`, payload);
  return res && res.data ? res.data : null;
};

export const checkPaymentStatus = async (data: any) => {
  const res = await axiosInstance.get(
    `${appConfig.bbbmiddleware}/payments/transaction?transactionId=${data}`
  );
  return res && res.data ? res.data : null;
};

//list of session
export const getSessionList = async (courseOfferingId: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/SessionData/?attendance=false&courseOfferingId=${courseOfferingId} `
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};

//list of students
export const getStudentList = async (CourseOfferingId: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/studentsByCourseOffering?CourseOfferingId=${CourseOfferingId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};
export const getStudentAttendanceDataPerCourseOffering = async (CourseOfferingId: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/StudentAttendanceDataPerCourseOffering?courseOfferingId=${CourseOfferingId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};
export const getTotalAttendenceList = async (CourseOfferingId: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/CourseOfferingAttendance/${CourseOfferingId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};
export const updateAssessmentSettings = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.updateAssessmentSettings}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

//----------Submissions of an Assignment---------

export const getSubmission = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getSubmission}`,
    {
      method: 'post',
      cmid: data?.cmid,
      status: data?.status,
      since: data?.since,
      before: data?.before,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const assignGetSubmissionStatus = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.assignGetSubmissionStatus}`,
    {
      method: 'post',
      cmid: data?.cmid,
      contactid: data?.contactid,
      groupid: data?.groupid,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const gradeAssignment = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.gradeAssignment}`,
    {
      assignmentid: data?.assignmentid,
      contactid: data?.contactid,
      method: 'post',
      mark: data?.mark,
      comment: data?.comment,
      filename: data?.filename,
      filecontent: data?.filecontent,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const createAssignmentAPI = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.createAssignment}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
export const uploadQuestioninQuiz = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.uploadQuestion}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  return res && res.data ? res.data : null;
};
export const uploadQuestionBulk = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.uploadQuestionbulk}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  return res && res.data ? res.data : null;
};
export const createResourceAPI = async (data: any, Url: string) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${Url}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const getResource = async (data: any, url: string) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${url}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
export const updateResource = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.updateResource}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const assignmentFileSubmission = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.fileSubmission}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const wsAssignLockSubmission = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.wsAssignLockSubmission}`,
    {
      method: 'post',
      cmid: data?.cmid,
      contactid: data?.contactid,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
export const getSessionData = async (contactId: any, courseOfferingId: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/SessionData/?contactId=${contactId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const wsAssignUnlockSubmission = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.wsAssignUnlockSubmission}`,
    {
      method: 'post',
      cmid: data?.cmid,
      contactid: data?.contactid,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
// GET BOOK REQUEST
export const getBookRequest = async (ContactId: any, AppID: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/getData?api=GetCase/${ContactId}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};
//POST BOOK REQUEST
export const postBookRequest = async (data: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/case`;
  const res = await axiosInstance.post(path, data);
  return res && res.data ? res.data : null;
};

// GET MARKS REQUEST
export const getMarksRequest = async (ContactId: any, AppID: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/getData?api=GetCase/${ContactId}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};
// GET CASE HISTORY
export const getCaseHistory = async (caseID: any, AppID: any) => {
  const path = `${appConfig.bbbmiddleware
    }/sf/getData?api=GetCaseHistory/${caseID}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};
//POST MARKS REQUEST
export const postMarksRequest = async (data: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/case`;
  const res = await axiosInstance.post(path, data);
  return res && res.data ? res.data : null;
};
export const postDashboardCases = async (data: any) => {
  const path = `${appConfig.bbbmiddleware
    }/sf/data?api=services/data/v53.0/sobjects/Case`;
  const res = await axiosInstance.post(path, data);
  return res && res.data ? res.data : null;
};
export const updateDashboardQuery = async (caseID: any, data: any) => {
  const path = `${appConfig.bbbmiddleware
    }/sf/data?api=services/data/v53.0/sobjects/Case/${caseID}`;
  const res = await axiosInstance.patch(path, data);
  return res && res.data ? res.data : null;
};

//post attendance event
export const postAttendanceEvent = async (data: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/createAttendanceEvent`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

//get session list with filters
export const getSessionListFilter = async (
  startDate: any,
  endDate: any,
  courseOfferingId: any
) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/SessionData/?attendance=true&startDate=${startDate}&endDate=${endDate}&courseOfferingId=${courseOfferingId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};

//get session list with filters
export const getattendancePerSession = async (sessionId: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `services/apexrest/attendancePerSession/?sessionId=${sessionId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};

//get Events Data
export const getEventsData = async () => {
  try {
    const path = 'v1/event/eventmanagement';
    const res: any = await axiosInstance.get(path);
    console.log(res, "resSetUp")
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

//post event register
export const postEventRegister = async (data: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/EventRegistration`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

//get event register
export const getEventRegister = async (eventId: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `services/apexrest/EventRegistration${eventId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  console.log(res, "Enverned")
  return res && res.data ? res.data : null;
};
// export default ApiService;

//LMS delete course module
export const deleteCourseModule = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.deleteCourseModule}`,
    {
      method: 'get',
      cmid: data?.cmid,
      module: data?.module,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
// LMS get quiz Totalattempted
export const getTotalattemptedQuiz = async (quizId: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.quizTotalattempted}`,
    {
      method: 'get',
      quizid: quizId,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

//update assignment
export const updateAssignmentSettings = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.updateAssignmentSettings}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const getAssignmentDetails = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getAssignmentDetails}`,
    {
      method: 'post',
      assignid: data?.assignid,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const AssignmentGetParticipant = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.assignmentGetParticipant}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
export const UpdateAssignmetSubmission = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.updateAssignmetSubmission}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
//get Events FiltersData
export const getEventsFiltersData = async () => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `services/apexrest/eventDropdownValues`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};

export const getAttendanceClassConducted = async (contactId: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/AttendanceCount/${contactId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};

//get teach history
export const getTeachHistory = async (contactId: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/allCourseConnections/?contactId=${contactId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};

//getStudents count
export const getStudentsCount = async (contactId: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/courseConnectionsPerStudent/?contactId=${contactId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};

/* LMS Forum API */
/* create Forum */
export const createForum = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.createForum}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

/* Update Forum */
export const updateForum = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.updateForum}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
/* Get Forum Discussions */
export const getForumDiscussions = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getForumDiscussions}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

/* Add Forum Discussion */
export const addForumDiscussion = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.addForumDiscussion}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

/* Add Forum Discussion Post*/
export const addForumDiscussionPost = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.addForumDiscussionPost}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

/* Set Fourm Subscription State*/
export const fourmSubscription = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.setFourmSubscriptionState}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

/* Get Fourm */
export const getForums = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getForums}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

/* get Forum Access Information*/
export const getForumAccessInformation = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getForumAccessInformation}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

/* get Discussion Posts*/
export const getDiscussionPosts = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getDiscussionPosts}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

/* star Toggle Discussion */
export const starToggleDiscussion = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.starToggleDiscussion}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

/* set Lock StateFor Discussion*/
export const lockToggleDiscussion = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.setLockStateForDiscussion}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

/* set Pin State For Discussion*/
export const pinToggleDiscussion = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.setPinStateForDiscussion}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

/* delete Forum Post */
export const deleteForumPost = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.deleteForumPost}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

//get Additional InfoData
export const getAdditionalInfoData = async (contactId: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/ContactAdditionalInfoData/?contactId=${contactId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};
//delete Additional InfoData
export const deleteAdditionalInfoData = async (data: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/createAdditionalInfo`);
  console.log('data==============>', data);
  const newData = {
    Operation: 'Delete',
    AdditionalInformation: data,
  };
  const res = await axiosInstance.post(`${path}${query}`, newData);
  return res && res.data ? res.data : null;
};

export const deleteStudentAddressInfo = async (id: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/getData?api=`;
  const query = encodeURIComponent(`Address/?recordId=${id}`);
  const res = await axiosInstance.delete(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const deleteEducationInfo = async (id: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/getData?api=`;
  const query = encodeURIComponent(`EducationHistoryApi/?recordId=${id}`);
  const res = await axiosInstance.delete(`${path}${query}`);
  return res && res.data ? res.data : null;
};
/* Get Forum  api*/
export const getForumDetails = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getForumDetails}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

/* get faculty activities count */
export const getFacultyActivitiesCount = async (data: any) => {
  const instance = await getIntegrationInstance();

  const res = await instance.post(
    `/lms/?endpoint=${UrlEndPoints.getFacultyActivitiesCount}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const getFacultyCourses = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getFacultyCourses}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

/* get user activities count */
export const getUserActivitiesCount = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getUserActivitiesCount}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
/* Get Latest Fourm */
export const getLatestForums = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getLatestForums}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
export const createURLResource = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.createURLResource}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
export const updateURLResource = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.updateURLResource}`,
    {
      method: 'post',
      cmid: data?.cmid,
      name: data?.name,
      externalurl: data?.externalurl,
      showdescription: data?.showdescription,
      display: data?.display,
      visible: data?.visible,
      visibleoncoursepage: data?.visibleoncoursepage,
      intro: data?.intro,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
// get URL Resource
export const getURLResource = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getURLResource}`,
    {
      method: 'post',
      cmid: data?.cmid,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
//
export const GetAttemptReview = async (attemptId: any) => {
  const instance = await getIntegrationInstance();
  let data = {
    attemptid: attemptId,
    page: '-1',
    method: 'get',
  };
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getAttemptReview}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  return res && res.data ? res.data : null;
};

export const getQuizReport = async (data: any) => {
  const instance = await getIntegrationInstance();
  let payload = {
    quizid: data?.quizid,
    method: 'get',
  };
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.getQuizReport}`,
    payload,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  return res && res.data ? res.data : null;
};
export const postAddWorkExperience = async (contactId: any, data: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/AddWorkExperience/${contactId}`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

// get students By CourseOffering for faculty
export const getStudentsByCourseOffering = async (courseOfferingId: any) => {
  const res = await axiosInstance.get(
    `${appConfig.bbbmiddleware
    }/sf/data?api=services/apexrest/getStudentsByCourseOffering/?courseOfferingId=${courseOfferingId}`
  );

  return res && res.data ? res.data : null;
};

export const getAzureWebUrl = async (userDetails: any) => {
  const data = JSON.parse(userDetails);
  const Name = data.Name;
  const first = Name.split(' ')
    .slice(0, -1)
    .join(' ');
  const last = Name.split(' ')
    .slice(-1)
    .join(' ');
  const res = await axiosInstance.post(KEY_AZURE_WEBSITE_URL, {
    userId: data.mail,
    firstName: first,
    lastName: last,
    mobile: '6383522927',
    country: {
      code: 'IN',
      name: 'india',
    },
  });
  return res;
};
//Get subject content
// export const getCourseContent = async (courseid:any, useridnumber:any) => {
//   const instance = await getIntegrationInstance();
//   const res = await instance.post(
//     `/lms?endpoint=${UrlEndPoints.getCourseContent}`,
//     {
//       method: 'post',
//       courseoffering: courseid,
//       useridnumber: useridnumber,
//     },
//     {
//       headers: {
//         Accept: 'application/json',
//         'Content-Type': 'application/json',
//       },
//     }
//   );
//   return res && res.data ? res.data : null;
// };
// //Get subject content faculty
// export const getCourseContentFaculty = async (courseid:any, useridnumber:any) => {
//   const instance = await getIntegrationInstance();
//   const res = await instance.post(
//     `/lms?endpoint=${UrlEndPoints.getCourseContentFaculty}`,
//     {
//       method: 'post',
//       courseoffering: courseid,
//       useridnumber: useridnumber,
//     },
//     {
//       headers: {
//         Accept: 'application/json',
//         'Content-Type': 'application/json',
//       },
//     }
//   );
//   return res && res.data ? res.data : null;
// };

export const manualGradeEssayQuestiontype = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.manualGradeEssayQuestiontype}`,
    {
      method: 'post',
      attemptid: data?.attemptid,
      questionid: data?.questionid,
      mark: data?.mark,
      // 'comment':data?.comment
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
export const mediaFileUpload = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.questionUploadmedia}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

interface UserDetails {
  Type: string;
  Name: string;
  ContactId: string;
  mail: string;
}

interface Schedule {
  Id: string;
  Name: string;
  CourseOfferingID: string;
  hed__Start_Time__c: string;
  hed__Start_Date__c: string;
  hed__End_Time__c: string;
  hed__End_Date__c: string;
  id?: string;
}

interface Config {
  bbbmiddleware: string;
  appId: string;
  prodUri: string;
  qaUri: string;
  devUri: string;
  redirectUri: string;
  [key: string]: any;  // Add this to allow additional properties
}

interface BBBResponse {
  moderatorLink?: string;
  studentLink?: string;
}

export const getDatesFromRrule = (
  rule: string,
  startDate: Date,
  endDate?: Date
): Date[] => {
  try {
    const rrule = rrulestr(rule);
    const rruleSet = new RRuleSet();
    rruleSet.rrule(rrule);
    const arr = rruleSet.between(startDate, endDate || startDate, true);
    return arr;
  } catch (error) {
    console.log('error in schedule: ', error);
    return [];
  }
};

export const transFormRrule = (rule: string): string => {
  const ruleArr = rule.split(';');
  ruleArr[1] = '\n' + ruleArr[1];
  return ruleArr.join(';');
};

export const generateLink = (
  schedule: Schedule,
  config: Config,
  date: string = dayjs().format(KEY_DATE_FORMAT)
): string | undefined => {
  if (date && date !== dayjs().format(KEY_DATE_FORMAT)) {
    return;
  }

  const userdetails: UserDetails = JSON.parse(
    localStorage.getItem('userDetails') || '{}'
  );
  let link: string;

  if (userdetails.Type === 'Faculty') {
    link = encodeURI(
      `${config.bbbmiddleware}/virtualClass/faculty?meetingName=${schedule.Name}&meetingId=${schedule.Id}&fullName=${userdetails.Name}&courseId=${schedule.CourseOfferingID}&ContactId=${userdetails.ContactId}&starttime=${schedule.hed__Start_Time__c}&startdate=${schedule.hed__Start_Date__c}&endtime=${schedule.hed__End_Time__c}&enddate=${schedule.hed__End_Date__c}&email=${userdetails.mail}`
    );
    return link;
  } else {
    link = encodeURI(
      `${config.bbbmiddleware}/virtualClass/student?courseId=${schedule.CourseOfferingID}&studentId=${userdetails.ContactId}&starttime=${schedule.hed__Start_Time__c}&startdate=${schedule.hed__Start_Date__c}&meetingId=${generateMeetingId(schedule?.id)}&contactId=${userdetails.ContactId}`
    );
    return link;
  }
};

export const onStartClass = async (
  bbbLinks: string,
  toggleLoader: (value: boolean) => void,
  config: any  // Change this to any temporarily
): Promise<void> => {
  const redirect = getUri(config) + '/closetab';
  const data = {
    token: localStorage.getItem('access_token') || '',
    redirectUrl: redirect,
  };

  try {
    const result = await axiosInstance.post(bbbLinks, data) as { data: BBBResponse };
    const link = result.data;

    if (link.moderatorLink) {
      toggleLoader(false);
      window.open(link.moderatorLink, '_blank');
    } else {
      console.log('Something went wrong');
      toggleLoader(false);
    }
  } catch (error) {
    console.log('error', error);
    toggleLoader(false);
  }
};

export const onJoinClass = async (
  bbbLinks: string,
  snackbar: () => void,
  toggleLoader: (value: boolean) => void
): Promise<void> => {
  try {
    const result = await axiosInstance.get(bbbLinks) as { data: BBBResponse };
    const link = result.data;

    if (link.studentLink !== 'link not found') {
      toggleLoader(false);
      window.open(link.studentLink, '_blank');
    } else {
      toggleLoader(false);
      snackbar();
    }
  } catch (error) {
    console.log('error', error);
    toggleLoader(false);
  }
};

const generateMeetingId = (id?: string): string => {
  return id ? `meeting_${id}` : 'default_meeting';
};

// events
export const getServices = async () => {
  try {
    const path = `/v1/support/get/service`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const postEventQuestionnaire = async (payload: Questionnaire) => {
  try {
    const path = `/v1/event/submitFeedback`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const getTicketHistory = async (accountId: string) => {
  try {
    const path = `/v1/support/get/user/case?userId=${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const getEventServicesById = async (eventId: string) => {
  try {
    const path = `/v1/support/get/service/Id?eventid=${eventId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const getCategoryPicklistValue = async () => {
  try {
    const path = `/v1/event/CategoryPicklistValue`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};


// service and support
export const getServicesOffering = async () => {
  try {
    const path = `/v1/support/get/serviceoffering`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const raiseComplaint = async (payload: FormPostJobFavorite) => {
  try {
    const path = `/v1/support/post/case`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const getFaq = async () => {
  try {
    const path = `/v1/support/get/faq`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const cancelService = async (id: string) => {
  try {
    const path = `/v1/support/delete/case?caseId=${id}`;
    const res: any = await axiosInstance.delete(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const getServicesById = async (accountId: string) => {
  try {
    const path = `/v1/support/get/service/Id?serviceid=${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const postQuestionnaire = async (payload: Questionnaire) => {
  try {
    const path = `/v1/support/questionnaire`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const cancelcase = async (payload: any) => {
  try {
    const path = `/v1/support/cancelcase/${payload}`;
    const res: any = await axiosInstance.patch(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

// attence trend
export const getAttendanceTrend = async (courseOfferingId: string) => {
  const path = `/sf/data?api=${encodeURIComponent(
    `/services/apexrest/attendanceTrend/${courseOfferingId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res.data;
};
// preapproved leaves
export const getPreApprovedLeaves = async (contactId: any) => {
  const path = `/sf/data?api=${encodeURIComponent(
    `/services/apexrest/LeaveApplication/${contactId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res.data;
};
export const replay = async (id: string) => {
  try {
    const path = `/v1/support/replay?caseid=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

// plan my program
export const planMyProgramList = async (contactId: string) => {
  try {
    const path = encodeURIComponent(`/services/apexrest/api/contacts/${contactId}/programenrollments`);
    const res = await axiosInstance.get(
      `${appConfig.bbbmiddleware}/salesforce?endpoint=${path}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'json',
      }
    );
    return res.data;
  } catch (error) {
    console.error("Error fetching programs:", error);
    return error;
  }
};
export const getTopicsByProgramPlan = async (programPlanId: string) => {
  try {
    const path = encodeURIComponent(`/services/apexrest/topics?programPlanId=${programPlanId}`);
    const res = await axiosInstance.get(
      `${appConfig.bbbmiddleware}/salesforce?endpoint=${path}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'json',
      }
    );
    return res.data;
  } catch (error) {
    console.error("Error fetching topics:", error);
    return error;
  }
};

export const getCSVTopicsByProgramPlan = async (programPlanId: string) => {
  try {
    const path = encodeURIComponent(`/services/apexrest/csvtopics?programPlanId=${programPlanId}`);
    const res = await axiosInstance.get(
      `${appConfig.bbbmiddleware}/salesforce?endpoint=${path}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'json',
      }
    );
    return res.data;
  } catch (error) {
    console.error("Error fetching topics:", error);
    return error;
  }
};
export const uploadTimetable = async (formData: FormData) => {
  try {
    const res = await axios.post(`${appConfig.bbbmiddleware}/csvupload`, formData, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
      },
    });

    return res && res.data ? res.data : null;
  } catch (error) {
    console.error('Error uploading timetable:', error);
    return null;
  }
};

export const saveTopicInfo = async (payload: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/topics`
  )}`;
  const res = await axiosInstance.post(`${appConfig.bbbmiddleware}/${path}`, payload);
  return res && res.data ? res.data : null;
};

export const saveCSVTopicInfo = async (payload: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/csvtopics`
  )}`;
  const res = await axiosInstance.post(`${appConfig.bbbmiddleware}/${path}`, payload);
  return res && res.data ? res.data : null;
};





